// extracted by mini-css-extract-plugin
export var button = "button-module--button--snjyh";
export var buttonText = "button-module--buttonText--fviDZ";
export var dark = "button-module--dark--o7Hka";
export var error = "button-module--error--4gD7H";
export var falconGray = "button-module--falconGray--FoC7P";
export var large = "button-module--large--a-h94";
export var medium = "button-module--medium--pPmUs";
export var outline = "button-module--outline--7tjus";
export var success = "button-module--success--OFi71";
export var text = "button-module--text--ySxcr";
export var tiny = "button-module--tiny--mK7IM";
export var white = "button-module--white--KrA2b";
export var withIcon = "button-module--withIcon--thUsH";